import { useContext } from "react";
import { useCreateReview } from "services/review";
import { CurrentUserContext } from "components/context/RequireAuth";
import { ReviewStatus } from "protogen/review_pb";
import ReactiveDialog from "../common/ReactiveDialog";
import ReviewForm from "./ReviewForm";

interface Props {
  open: boolean;
  onClose: (created?: boolean) => void;
  advisorRef?: string;
  isAdmin?: boolean;
}

export default ({ open, onClose, advisorRef, isAdmin = false }: Props) => {
  const currentUser = useContext(CurrentUserContext);
  const { request, loading } = useCreateReview(() => {
    onClose(true);
  });

  const handleSubmit = (
    text: string,
    starCount: number,
    displayName?: string,
  ) => {
    if (!currentUser?.ref) return;

    request({
      submitterRef: currentUser.ref,
      subjectRef: advisorRef || "",
      displayName: displayName || "",
      text,
      starCount,
      status: isAdmin ? ReviewStatus.APPROVED : ReviewStatus.PENDING,
    });
  };

  return (
    <ReactiveDialog
      fullWidthSize="sm"
      open={open}
      onClose={() => onClose(false)}
      title="Share a review"
    >
      <ReviewForm
        onSubmit={handleSubmit}
        loading={loading}
        onCancel={() => onClose(false)}
        showDisplayName={isAdmin}
        currentUser={currentUser}
      />
    </ReactiveDialog>
  );
};
